module.exports = __webpack_public_path__ + "media/slide2/contractMediaSlide2Part3vs-8d6ad9ab.png";